export default "__VITE_PUBLIC_ASSET__70521dfe__"